import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useFirebase } from "../database/FirebaseContext";
import { setLocalUser } from "../database/localStorage";

function LoginPage() {
	// errorMessage variable to determine whether the error message should pop out
	const [errorMessage, setErrorMessage] = useState(false);

	const { getUser } = useFirebase();

	const [currentUser, setCurrentUser] = useState({
		userName: "",
		userPassword: "",
	});

	const handleChange = (event) => {
		const { name, value } = event.target;
		setCurrentUser((values) => ({ ...values, [name]: value }));
	};

	const handleSubmit = async (event) => {
		event.preventDefault();

		try {
			const user = await getUser(
				currentUser.userName,
				currentUser.userPassword
			);

			if (user === undefined) {
				setErrorMessage(true);
			} else if (user.userPassword === currentUser.userPassword) {
				setLocalUser(currentUser);
				window.location.href = "/productbacklog";
			} else {
				setErrorMessage(true);
			}
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<div
			style={{ backgroundColor: "#3D3E44" }}
			className="min-h-screen flex flex-col justify-center items-center relative"
		>
			<h1 className="text-white text-4xl font-semibold text-center mb-2">
				&lt;SoftControl/&gt;
			</h1>
			<h2 className="text-white text-sm text-center mb-6">
				Crafting tomorrow’s Code today
			</h2>
			<div className="bg-secondary rounded-lg p-8 max-w-xl w-11/12 md:w-96 md:h-96 md:max-w-3xl">
				<h1 className="text-white text-2xl font-semibold text-center mb-6">
					Login
				</h1>
				<form onSubmit={handleSubmit}>
					<div className="mt-12">
						<input
							type="text"
							id="userName"
							name="userName"
							onChange={handleChange}
							placeholder="Username"
							required
							className="w-full py-2 px-3 rounded bg-[#C3C1C1] text-black"
						/>
					</div>
					<div className="mt-4">
						<input
							type="password"
							id="userPassword"
							name="userPassword"
							onChange={handleChange}
							placeholder="Password"
							required
							className="w-full py-2 px-3 rounded bg-[#C3C1C1] text-black"
						/>
					</div>

					{/* error message */}

					{errorMessage === true && (
						<p className="mt-8 py-2 px-4 bg-[#3D3E44] rounded text-white text-sm mx-auto block hover:bg-primary hover:text-white transition-colors text-center ">
							The username or password you entered is incorrect.
						</p>
					)}

					<button
						type="submit"
						className="mt-4 w-32 py-2 px-4 bg-[#3D3E44] rounded text-white mx-auto block hover:bg-primary font-bold hover:text-white transition-colors "
					>
						Login
					</button>
				</form>
			</div>
			<p className="text-white text-right absolute bottom-4 right-4">
				<i className="fa-solid fa-copyright text-white" /> 2023
				&lt;SoftControl/&gt; All rights reserved.
			</p>
		</div>
	);
}

export default LoginPage;
